import { CHANGE_SORTING } from '../constants/sorting';

// eslint-disable-next-line
export const changeSortingAction = (payload) => ({
  type: CHANGE_SORTING,
  payload,
});
